export default __webpack_public_path__ + "static/media/A3.b9cd561c.png";